import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the SortPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'sort',
})
export class SortPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  // transform(value: string, ...args) {
  //   return value.toLowerCase();
  // }
  // 
  transform(records: any, args?: any): any {
  records = records || [];
  return records.sort(function(a, b){
	    if(a[args.property] < b[args.property]){
	        return -1 * args.order;
	    }
	    else if( a[args.property] > b[args.property]){
	        return 1 * args.order;
	    }
	    else{
	        return 0;
	    }
	  });
	}

}



// WEBPACK FOOTER //
// ./src/pipes/sort/sort.ts